import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import { palette } from "../../../assets/styles/Palette";
import PopupWrap from "../../../assets/styles/Popup";
import { Button } from "../../../assets/styles/ButtonStyle";
import MoleculeHeader from "../../Global/components/molecules/MoleculeHeader";
import {
  ContentsWrap,
  MainContent,
  PopupContent,
} from "../../../assets/styles/BusinessAnalysisStyle";
import {
  H1,
  Body3,
  Body2,
  Sub2,
} from "../../../assets/styles/Typography";
import {
  createCustomerOnServer,
  updateCustomerOnServer,
  getCustomerListOnServer,
  getUserMemberType,
  getOrganizationUserListOnServer,
} from "../../../utils/indexedDB";

import OrganismCustomerItemInfoBoard from "../components/organisms/OrganismCustomerItemInfoBoard";

import {
  IS_LOGGED_IN,
  CUSTOMER_LIST,
  CUSTOMER_ID,
  MEMBER_TYPE,
  CUSTOMER_DETAIL,
} from "../../AtomStates";
import { useDynamicViewport } from "../../../assets/DynamicViewport";

const PageCustomerManageInfoBoard = () => {
  useDynamicViewport("width=1280"); // 특정페이지에서만 pc화면처럼 보이기
  const navigate = useNavigate();
  const [isLoggedIn] = useAtom(IS_LOGGED_IN);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [showCustomerPopup, setShowCustomerPopup] = useState(false);
  const [companyName, setCompanyName] = useState("");
  const [address, setAddress] = useState("");
  const [companyInfo, setCompanyInfo] = useState("");
  const [customerList, setCustomerList] = useAtom(CUSTOMER_LIST);
  const [organizationUserList, setOrganizationUserList] = useState([]);
  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);

  const [memberType, setMemberType] = useAtom(MEMBER_TYPE);
  const [customerDetail, setCustomerDetail] = useAtom(CUSTOMER_DETAIL);

  const [isEdit, setIsEdit] = useState(false);
  const [initialCustomer, setInitialCustomer] = useState({
    companyName: "",
    address: "",
    companyInfo: "",
    boardType: "general",
  });

  const [boardType, setBoardType] = useState("class"); // boardType 상태 추가, 기본값 "class"
  const [boardTypeDropdownOpen, setBoardTypeDropdownOpen] = useState(false); // 드롭다운 열림 상태

  const getOrganizationUserList = async () => {
    const organizationUserList = await getOrganizationUserListOnServer();
    setOrganizationUserList(organizationUserList.data);
    setShowCustomerPopup(true);
  };

  useEffect(() => {
    // 새로고침 감지 함수
    const detectRefresh = () => {
      //  현재 URL 확인
      const currentUrl = window.location.href;

      // 현재 URL 저장
      sessionStorage.setItem("lastUrl", currentUrl);
      const lastUrl = sessionStorage.getItem("lastUrl");
    };
    // 함수 실행
    detectRefresh();

    // 컴포넌트 마운트 시 한 번만 실행
  }, [navigate]);

  useEffect(() => {
    const loadCustomerList = async () => {
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);

      setMemberType(userMemberType.member_type);

      try {
        let customerListResponse;

        customerListResponse = await getCustomerListOnServer(
          4,
          999,
          1,
          isLoggedIn
        );

        if (customerListResponse) {
          setCustomerList(customerListResponse.data);
        }
        console.log(customerListResponse);
      } catch (error) {
        console.error("Failed to load customer list:", error);
      }
    };
    loadCustomerList();
  }, [refreshTrigger, isLoggedIn]);

  const handleCustomerSubmit = async (editId) => {
    try {
      console.log(editId);
      setShowCustomerPopup(false);
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);

      const data = {
        companyName: companyName,
        address: address,
        companyInfo: companyInfo,
        customerType: 4,
      };

      if (isEdit) {
        await updateCustomerOnServer(editId, data);
      } else {
        const customerId = await createCustomerOnServer(isLoggedIn);
        await updateCustomerOnServer(customerId, data);
      }
  
      // 저장 후 리스트 다시 불러오기
      let customerListResponse;
 
      customerListResponse = await getCustomerListOnServer(
        4,
        999,
        1,
        isLoggedIn
      );
      if (customerListResponse) {
        setCustomerList(customerListResponse.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setCompanyName("");
      setAddress("");
      setCompanyInfo("");
      setBoardType("class"); // boardType 초기화
      setInitialCustomer({
        companyName: "",
        address: "",
        companyInfo: "",
        boardType: "general",
      });
      setCustomerId("");
      setCustomerDetail(null);
      setIsEdit(false);
      setBoardTypeDropdownOpen(false);
    }
  };

  return (
    <>
      <ContentsWrap>
        <MoleculeHeader />
        <MainContent Wide1030>
          <ProjectWrap>
            <HeaderWrap>
              <div
                style={{ display: "flex", flexDirection: "row", gap: "10px" }}
              >
                <div>
                  <H1 color="gray800" align="left">
                      고객사 관리
                  </H1>
                  <div style={{ height: "10px" }}></div>
                  <Body3 color="gray700" align="left">
                    등록된 고객사의 디스플레이와 콘텐츠를 손쉽게 관리해보세요
                  </Body3>
                </div>
              </div>
                <div
                  style={{ display: "flex", flexDirection: "row", gap: "10px" }}
                >
                  <Button
                    Large
                    Primary
                    Fill
                    onClick={() => {
                        setShowCustomerPopup(true);
                      }
                    }
                  >
                    <Sub2 color="white">
                      신규 고객사 등록
                    </Sub2>
                  </Button>
                </div>
            </HeaderWrap>

            <ProjectListWrap>
                <ProjectList>
                  {customerList.map((customer) => (
                    <OrganismCustomerItemInfoBoard
                      key={customer._id}
                      setShowCustomerPopup={setShowCustomerPopup}
                      setCompanyName={setCompanyName}
                      setAddress={setAddress}
                      setCompanyInfo={setCompanyInfo}
                      setBoardType={setBoardType}
                      setInitialCustomer={setInitialCustomer}
                      setIsEdit={setIsEdit}
                      customer={customer}
                      selectedCustomerId={setCustomerId}
                      getOrganizationUserList={getOrganizationUserList}
                    />
                  ))}
                  <OrganismCustomerItemInfoBoard
                    isNoData={true}
                    setShowCustomerPopup={setShowCustomerPopup}
                    setBoardType={setBoardType}
                    boardType="general"
                    getOrganizationUserList={getOrganizationUserList}
                    onClick={() => {
                      setCompanyName("");
                      setAddress("");
                      setCompanyInfo("");
                      setBoardType("general");
                      setCustomerDetail(null);
                      setIsEdit(false);
                      setShowCustomerPopup(true);
                      setBoardTypeDropdownOpen(false);
                    }}
                  />
                </ProjectList>
            </ProjectListWrap>
          </ProjectWrap>
        </MainContent>
      </ContentsWrap>

      {showCustomerPopup && (
        <PopupWrap
          TitleFlex
          title={
            isEdit
              ? "고객사 정보"
              : "고객사 등록하기"
          }
          buttonType="Fill"
          confirmText={isEdit ? "편집 내용 저장" : "게시판 등록하기"}
          isModal={true}
          onCancel={() => {
            setShowCustomerPopup(false);
            setIsEdit(false);
            setCompanyName("");
            setAddress("");
            setCompanyInfo("");
            setBoardType("general");
            setCustomerDetail(null);
            setBoardTypeDropdownOpen(false);
          }}
          onConfirm={
            isEdit
              ? () => handleCustomerSubmit(customerId)
              : handleCustomerSubmit
          }
          showTabs={true}
          eventState={false}
          creditRequestCustomPersona={100}
           isFormValid={
            !!companyName &&
            !!address &&
            (companyName !== customerDetail?.companyName ||
              address !== customerDetail?.address ||
              companyInfo !== customerDetail?.companyInfo)
          }
          body={
            <div>
              <>
                <div className="column">
                  <Body2 color="gray700" align="left">
                    고객사 명
                    <span style={{ color: "red" }}>*</span>
                  </Body2>
                  <PopupContent>
                    <InputBox>
                      <InputText
                        placeholder="입력해주세요"
                        value={companyName}
                        onChange={(e) => setCompanyName(e.target.value)}
                      />
                    </InputBox>
                  </PopupContent>
                </div>
                <div className="column">
                  <Body2 color="gray700" align="left">
                    주소지
                    <span style={{ color: "red" }}>*</span>
                  </Body2>
                  <PopupContent>
                    <InputBox>
                      <InputText
                        placeholder="입력해주세요"
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </InputBox>
                  </PopupContent>
                </div>
                <div className="column">
                  <Body2 color="gray700" align="left">
                    고객사 관련 정보
                  </Body2>
                  <PopupContent>
                    <InputBox2>
                      <InputTextArea
                        value={companyInfo}
                        onChange={(e) => setCompanyInfo(e.target.value)}
                        placeholder="입력해주세요"
                        rows={4}
                      />
                    </InputBox2>
                  </PopupContent>
                </div>
              </>
            </div>
          }
        />
      )}
    </>
  );
};

export default PageCustomerManageInfoBoard;

const ProjectWrap = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 54px;
  margin: 50px auto;
`;

const HeaderWrap = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

const ProjectListWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ProjectList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

export const BgBoxItem = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 4px;
  width: 100%;
  padding: ${(props) => (props.NoOutline ? "12px" : "8px 12px")};
  border-radius: 10px;
  border: ${(props) =>
    props.NoOutline ? "0" : `1px solid ${palette.outlineGray}`};
  background: ${(props) => (props.white ? palette.white : palette.chatGray)};
`;

export const CheckCircle = styled.input`
  appearance: none;
  display: block !important;
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  background-image: ${(props) =>
    props.checked
      ? `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='12' fill='%23226FFF'/%3E%3Cpath d='M6.76562 12.4155L9.9908 15.6365L17.2338 8.36426' stroke='white' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`
      : `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none'%3E%3Ccircle cx='12' cy='12' r='11.5' stroke='%23E0E4EB'/%3E%3C/svg%3E")`};
  transition: background-image 0.3s ease-in-out;

  + label {
    cursor: pointer;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;

    + label {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
`;

const InputBox = styled.div`
  height: 56px;
  padding: 0 16px;
  background: rgba(179, 183, 186, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: center;
  width: 100%;
`;

const InputBox2 = styled.div`
  height: 150px;
  padding: 0 16px;
  background: rgba(179, 183, 186, 0.1);
  border-radius: 8px;
  display: flex;
  align-items: flex-start;
  width: 100%;
`;

const InputText = styled.input`
  width: 100%;
  border: none;
  background: transparent;
  color: ${palette.gray800};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
  outline: none;
  &::placeholder {
    color: ${palette.gray300};
  }
`;

const InputTextArea = styled.textarea`
  width: 100%;
  border: none;
  background: transparent;
  color: ${palette.gray800};
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  line-height: 28.5px;
  outline: none;
  padding-top: 16px;
  resize: none;
  &::placeholder {
    color: ${palette.gray300};
  }
`;